import useBaseIndex from "../../base/hooks/useBaseIndex";
import { HousekeepingResponseSchema } from "../response/IndexHousekeepingResponse";

const API_VERSION = "v3";

interface IndexHousekeepingProps {
    filters?: { [key: string]: any };
    search?: string;
    paginate?: number;
    page?: number;
    [key: string]: any;
}

const useIndexHousekeeping = (query: IndexHousekeepingProps) =>
    useBaseIndex({
        ...query,
        queryKey: "housekeeping-list",
        endpoint: `${API_VERSION}/housekeeping`,
        schema: HousekeepingResponseSchema,
    });

export default useIndexHousekeeping;